import script from "./Overview.vue?vue&type=script&setup=true&lang=ts"
export * from "./Overview.vue?vue&type=script&setup=true&lang=ts"

import "./Overview.vue?vue&type=style&index=0&id=635c2a7b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-635c2a7b"]])

export default __exports__